import React, { useEffect, useState } from 'react';

/**
 * Fine barre de progression animée affichée en haut du contenu pendant
 * le chargement lazy d'une page. N'affiche rien pendant les 150 premières
 * ms pour éviter le flash sur les chargements quasi-instantanés.
 */
export const PageTopLoader = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="page-top-loader"
      className="fixed top-0 left-0 right-0 lg:left-64 h-[3px] z-[60] overflow-hidden pointer-events-none"
    >
      <div className="page-top-loader-bar h-full bg-indigo-600 rounded-r-full" />
      <style>{`
        @keyframes pageTopLoader {
          0%   { left: -40%; width: 40%; }
          50%  { left: 30%;  width: 50%; }
          100% { left: 100%; width: 30%; }
        }
        .page-top-loader-bar {
          position: absolute;
          top: 0;
          animation: pageTopLoader 1.1s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default PageTopLoader;
